import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

import { dispatchAddAlert } from "../../../../../utils/alerts";
import { NO_DISCOUNT_DATA_SELECTED } from "../../../../../types/alerts";
// APP COMPONENTS
import MoneyInput from "../../../../Inputs/MoneyInput";
import PercentageInput from "../../../../Inputs/percentageInput";
// SERVICES
import { getDiscountCoupons } from "../../../../../api/discountCoupons";
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Popper from "@mui/material/Popper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import { IconStackButton } from "../../../../styled/button";
import { CustomModalRoot } from "../../../../styled/modal";
import {
  SegmentedControlContainer,
  SegmentedControlButton,
} from "../../../../styled/pos/windows11";
// ICONS
import PercentIcon from "@mui/icons-material/Percent";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { grey } from "@mui/material/colors";
import { validateArray } from "../../../../../common/validators";
import { getDeliveryCenterConfig } from "../../../../../api/DeliveryCenter/deliveryCenter";
import LoadingBox from "../../../../indicators/LoadingBox";
import { formatFinance } from "../../../../../utils/formatters";

export default function AddDiscountModal({
  showModal,
  closeModal,
  addDiscount,
  total,
}) {
  const [loading, setLoading] = useState(false);
  const [configs, setConfigs] = useState(null);

  const [selectedDiscountType, setSelectedDiscountType] =
    useState("DISCOUNT_COUPON");
  const [discountMoneyAmountValue, setDiscountMoneyAmountValue] = useState("");
  const [discountPercentageValue, setDiscountPercentageValue] = useState("");

  const [selectedDiscountCoupon, setSelectedDiscountCoupon] = useState(null);
  const [treatedDiscountCoupons, setTreatedDiscountCoupons] = useState([]);
  const [discountCouponPercentageValue, setDiscountCouponPercentageValue] =
    useState("");

  useEffect(() => {
    loadConfig();
  }, []);

  useEffect(() => {
    if (selectedDiscountType === "DISCOUNT_COUPON") {
      loadDiscountCoupons();
    }
  }, [selectedDiscountType]);

  const loadConfig = async () => {
    try {
      setLoading(true);

      const params = {
        config:
          "allow_coupons_discounts,allow_percentage_discount,allow_money_discount",
      };
      const { data } = await getDeliveryCenterConfig(params);
      setConfigs(data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const loadDiscountCoupons = async () => {
    try {
      const params = {
        is_active: true,
      };

      const { data } = await getDiscountCoupons(params);
      const treatedData = data.map((option) => {
        return {
          label: option.code,
          value: option.value,
          id: option.id,
        };
      });

      setTreatedDiscountCoupons(treatedData);
    } catch (e) {
      console.log(e);
    }
  };

  const handleChangeDiscountCoupon = (discountCoupon) => {
    setSelectedDiscountCoupon(discountCoupon.id);
    setDiscountPercentageValue(discountCoupon.value);
    setDiscountCouponPercentageValue(discountCoupon.value);
  };

  const calculatePercentage = (percentage) => {
    const amount = total * (percentage / 100);
    return amount.toFixed(2);
  };

  const handleSubmit = () => {
    if (selectedDiscountType === "PERCENTAGE") {
      if (!discountPercentageValue) {
        return dispatchAddAlert({
          message: NO_DISCOUNT_DATA_SELECTED,
        });
      }

      const value_percentage = calculatePercentage(
        parseFloat(discountPercentageValue)
      );
      const discountOj = {
        type: selectedDiscountType,
        type_value: discountPercentageValue,
        percentage: discountPercentageValue,
        name: "MERCHANT",
        target: "CART",
        value: parseFloat(value_percentage),
        id: uuidv4(),
      };
      addDiscount(discountOj);
    } else if (selectedDiscountType === "DISCOUNT_COUPON" && validateArray()) {
      if (!discountPercentageValue) {
        return dispatchAddAlert({
          message: NO_DISCOUNT_DATA_SELECTED,
        });
      }

      const value_percentage = calculatePercentage(
        parseFloat(discountPercentageValue)
      );
      const discountOj = {
        type: selectedDiscountType,
        type_value: discountPercentageValue,
        percentage: discountPercentageValue,
        name: "MERCHANT",
        target: "CART",
        value: parseFloat(value_percentage),
        discount_coupon_code: selectedDiscountCoupon.code,
        fk_discount_coupon: selectedDiscountCoupon.id,
        id: uuidv4(),
      };
      addDiscount(discountOj);
    } else {
      if (!discountMoneyAmountValue) {
        return dispatchAddAlert({
          message: NO_DISCOUNT_DATA_SELECTED,
        });
      }

      const discountOj = {
        type: selectedDiscountType,
        type_value: parseFloat(discountMoneyAmountValue),
        name: "MERCHANT",
        target: "CART",
        value: parseFloat(discountMoneyAmountValue),
        id: uuidv4(),
      };
      addDiscount(discountOj);
    }
  };

  if (loading) {
    return <LoadingBox height={100} />;
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={showModal}
      onClose={closeModal}
      closeAfterTransition
      sx={{
        zIndex: 999999,
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Fade in={showModal}>
        <CustomModalRoot top={50} left={50} width={50} height={95}>
          <Box>
            <Typography
              variant="body1"
              sx={{
                p: 1,
                my: 3,
                borderRadius: 2,
                backgroundColor: grey[100],
              }}
            >
              Selecione o Método de Desconto
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <SegmentedControlContainer>
                {configs?.allow_coupons_discounts && (
                  <SegmentedControlButton
                    selected={selectedDiscountType === "DISCOUNT_COUPON"}
                    onClick={() => setSelectedDiscountType("DISCOUNT_COUPON")}
                  >
                    <LocalOfferIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">Cupom</Typography>
                  </SegmentedControlButton>
                )}
                {configs?.allow_percentage_discount && (
                  <SegmentedControlButton
                    selected={selectedDiscountType === "PERCENTAGE"}
                    onClick={() => setSelectedDiscountType("PERCENTAGE")}
                  >
                    <PercentIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">Porcentagem</Typography>
                  </SegmentedControlButton>
                )}
                {configs?.allow_money_discount && (
                  <SegmentedControlButton
                    selected={selectedDiscountType === "MONEY_AMOUNT"}
                    onClick={() => setSelectedDiscountType("MONEY_AMOUNT")}
                  >
                    <CurrencyExchangeIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">Valor Fixo</Typography>
                  </SegmentedControlButton>
                )}
              </SegmentedControlContainer>
            </Box>
          </Box>
          <Box>
            <Typography
              variant="body1"
              sx={{
                p: 1,
                mt: 3,
                mb: 1,
                borderRadius: 2,
                backgroundColor: grey[100],
              }}
            >
              Informe o Valor do Desconto
            </Typography>
            <Stack
              spacing={1}
              sx={{
                p: 1,
                mb: 4,
                borderRadius: 2,
                backgroundColor: grey[100],
              }}
            >
              <Typography variant="body1" align="center" fontWeight="bold">
                Total
              </Typography>
              <Typography variant="body1" align="center">
                {formatFinance(total)}
              </Typography>
            </Stack>
            <Box display="flex" justifyContent="center">
              {selectedDiscountType === "MONEY_AMOUNT" && (
                <MoneyInput
                  label="Desconto"
                  value={discountMoneyAmountValue}
                  setValue={setDiscountMoneyAmountValue}
                />
              )}
              {selectedDiscountType === "PERCENTAGE" && (
                <PercentageInput
                  label="Desconto"
                  value={discountPercentageValue}
                  onChange={setDiscountPercentageValue}
                />
              )}
              {selectedDiscountType === "DISCOUNT_COUPON" && (
                <Stack spacing={2}>
                  <Autocomplete
                    id="discount-coupons-list"
                    disableClearable
                    options={treatedDiscountCoupons}
                    onChange={(event, newValue) => {
                      handleChangeDiscountCoupon(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cupons"
                        variant="outlined"
                      />
                    )}
                    PopperComponent={(props) => (
                      <Popper {...props} style={{ zIndex: 9999999 }} />
                    )}
                  />

                  <PercentageInput
                    label="Desconto"
                    value={discountCouponPercentageValue}
                    onChange={() => {}}
                    disabled
                  />
                </Stack>
              )}
            </Box>
          </Box>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            display="flex"
            sx={{ mt: 5 }}
          >
            <Button variant="contained" onClick={closeModal}>
              Voltar
            </Button>
            <Button variant="contained" color="success" onClick={handleSubmit}>
              Confirmar
            </Button>
          </Stack>
        </CustomModalRoot>
      </Fade>
    </Modal>
  );
}
